/*!
 * 
 * ------
 * Note: customizing files reduces the store's ability to auto-update the theme.
 *
 * Disclaimer:
 * This is a non minified version of a core js file, you can swap out the liquid / HTML link from the minified file if you choose to utilize this one. Any usage of these files is at the merchant/app/expert/agency's own risk, we take no responsibility for custom code changes. Support offerings from We Are Eight will be limited to rolling back to the latest theme version if these are utilized.
 *
 * License and acceptance of usage:
 *
 * Copyright (C) We Are Eight LTD  - All Rights Reserved
 * This file is part of Influence theme provided for usage on Shopify online stores only.
 * Unauthorized usage and or modification of this file outside of this Influence utilized on a Shopify store without a valid license, is strictly prohibited.
 * Unauthorized copying or distribution of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 *
 * More information and official contact details: weareeight.com
 * ------
 *
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 845:
/***/ ((module) => {

!function(e,d){ true?module.exports=d():0}(self,(function(){return(()=>{"use strict";var e={};return((e,d)=>{Object.defineProperty(d,"__esModule",{value:!0}),d.isArmadaLoaded=void 0,d.isArmadaLoaded=e=>{var d,o;const a=!0===(null===(o=null===(d=window.eight)||void 0===d?void 0:d.armada)||void 0===o?void 0:o.loaded);if(!e)return a;a?e():document.addEventListener("ARMADA:LOADED",e)},d.default=d.isArmadaLoaded})(0,e),e})()}));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/* harmony import */ var _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(845);
/* harmony import */ var _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__);


class LoadMore extends HTMLElement {
  constructor() {
    super()

    this.loadMoreBtn = this.querySelector('button');
    this.onLoadMore = this.handleLoadMore.bind(this);
    this.autoLoad = this.autoLoadMore.bind(this);
  }

  connectedCallback() {
    (0,_weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__.isArmadaLoaded)(this.init.bind(this));
  }

  init() {
    // If there are more pages, load their content
    if (this.dataset.armadaPaginateNext) {
      this.loadMoreBtn.addEventListener('click', this.onLoadMore, true);
        window.addEventListener('scroll',this.autoLoad,true);
    }
    window.eight.armada.elementRegistry.register({key: 'pagination-load-more', assetPath: '/assets/component-pagination-load-more.js'});
  }
  autoLoadMore(){
    const scrollTop = document.documentElement.scrollTop;
    const clientHeight = document.documentElement.clientHeight;
        
    const isVisible1 = this.loadMoreBtn.offsetTop + this.loadMoreBtn.offsetHeight >= scrollTop;
    const isVisible2 = this.loadMoreBtn.offsetTop < scrollTop + clientHeight;
    if(isVisible1 && isVisible2){        
      this.loadMoreBtn.click();
    }
    
  }
  handleLoadMore() {
    this.loadMoreBtn.removeEventListener('click', this.onLoadMore, true);
    this.changeButtonState(this.loadMoreBtn.querySelector('[data-armada-button-load-icon]'), this.loadMoreBtn.querySelector('[data-armada-button-text]'));
    window.eight.sectionsEngine.sectionRenderingEngine.fetchSection(this.dataset.armadaPaginateNext, [this.dataset.sectionId], [this], [''], this.loadNewContent.bind(this));
  }

  changeButtonState(icon, text) {
    // Hide the button text and show the loading icon
    if (!text || !icon) return;
    text.classList.add('invisible');
    icon.classList.remove('hidden');
  }

  loadNewContent(data) {
    // Remove the load more button when new content loads
    this.remove();

    const html = new DOMParser().parseFromString(data, 'text/html');
    const gridSelector = '[data-armada-selector="collection-grid-main"]';
    const btnSelector = 'load-more-pagination';

    // Add next page items to the current page
    const outerElement = document.querySelector(gridSelector);
    const destination = document.querySelector(gridSelector).firstElementChild;
    const gridItems = html.querySelector(gridSelector).firstElementChild.childNodes;
    const loadMoreButton = html.querySelector(btnSelector);

    if (gridItems && destination) destination.append(...gridItems);
    if (loadMoreButton && outerElement) outerElement.appendChild(loadMoreButton);

    // Reload animations
    const animComponent = destination.closest('loadin-animation');
    if (animComponent) animComponent.setAttribute('reload', true);

     var mySwiper = new Swiper ('.section-collection-grid .bundle-swatch-slider', {
    direction: 'horizontal', // 垂直切换选项
    slidesPerView:3,
    spaceBetween: 0,
    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: { 
      320: {  //当屏幕宽度大于等于320
        slidesPerView: 3,
        spaceBetween: 0
      },
      768: {  //当屏幕宽度大于等于768 
        slidesPerView: 4,
        spaceBetween: 5
      },
      1280: {  //当屏幕宽度大于等于1280
        slidesPerView: 5,
        spaceBetween: 8
      }
    }
         });
  }
}


customElements.define('load-more-pagination', LoadMore);

})();

/******/ })()
;